import Noop from "@marginly/ui/components/helpers/noop";
import cn from "classnames";
import React, { useRef } from "react";
import { useSwipeable } from "react-swipeable";

import { SWIPEABLE_CONFIG } from "@/constants/common";
import { useClickOutside } from "@/hooks/common";

import {
  ModalBody,
  ModalWrapper,
  SwipeableWrapper,
} from "../wallet-modal/styled";
import ModalCommon from "./common";

interface Props {
  onHide?: () => void;
  onConnectClick: () => void;
}

function handleSwap(onHide?: () => void) {
  return typeof window !== undefined
    ? () => {
        document.getElementById("swiper")?.classList.add("hidden");
        document.getElementById("swiper-wrapper")?.classList.add("hidden");

        setTimeout(() => {
          document.body.style.overflow = "visible";
          onHide?.();
        }, 300);
      }
    : undefined;
}

export const WalletModalLight = ({ onHide, onConnectClick }: Props) => {
  const ref = useRef(null);

  const swiper = useSwipeable({
    onSwipedDown: handleSwap(onHide),
    ...SWIPEABLE_CONFIG,
  });

  useClickOutside(ref, () => {
    document.body.style.overflow = "visible";
    onHide?.();
  });

  const visible = true;

  const handleConnectClick = () => {
    onHide?.();
    onConnectClick();
  };

  return (
    <SwipeableWrapper
      className={cn({
        visible: visible,
      })}
      id="swiper-wrapper"
    >
      {visible ? (
        <div {...swiper} id="swiper">
          <ModalWrapper
            onClick={onHide}
            ref={ref}
            className={cn({
              visible: visible,
            })}
          >
            <ModalBody
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
              }}
              className={cn({
                visible: visible,
              })}
            >
              <div>
                <ModalCommon onConnectClick={handleConnectClick} />
              </div>
            </ModalBody>
          </ModalWrapper>
        </div>
      ) : (
        <Noop />
      )}
    </SwipeableWrapper>
  );
};
